import React, { useEffect, useState, useCallback } from "react";
import ServiceProvider from "./ServiceProvider";
import {
  getAllServiceProviders,
  addServiceProvider,
  getTaxpayerActivities,
} from "../../api/methods";
import Loading from "../../components/shared/Loading";
import {showToast} from '../../helpers/showToast';

const ServiceProviderContainer = ({ tab, ...props }) => {
  const [loader, setLoader] = useState(false);
  const [serviceProviders, setServiceProviders] = useState([]);
  const [taxpayerActivities, setTaxpayerActivities] = useState([]);
  const [loading, setLoading] = useState({
    fetchingActivities: false,
    addingProvider: false,
  });

  const [search, setSearch] = useState({
    taxNumber: "",
  });

  const [taxpayerSearch, setTaxpayerSearch] = useState("");

  // Fetch all service providers with useCallback to fix dependency warning
  const handleGetAllServiceProviders = useCallback(() => {
    setLoader(true);
    getAllServiceProviders(search)
      .then((response) => {
        setLoader(false);
        // Handle both response.data and direct response array
        setServiceProviders(response.data || response || []);
      })
      .catch((err) => {
        console.error("Error fetching service providers:", err);
        setLoader(false);
        showToast({
          toastOptions: {type: "error",}, data: {
            variant: 'error', text: err.error,
          },
        })
      });
  }, [search]);

  // Search for taxpayer activities
  const handleSearchTaxpayer = (taxNumber) => {
    if (!taxNumber) {
      setTaxpayerActivities([]);
      return;
    }

    setLoading((prev) => ({ ...prev, fetchingActivities: true }));
    getTaxpayerActivities(taxNumber)
      .then((response) => {
        // Handle both response.data and direct response array
        setTaxpayerActivities(response.data || response || []);
      })
      .catch((err) => {
        console.error("Error fetching taxpayer activities:", err);

        setTaxpayerActivities([]);
      })
      .finally(() => {
        setLoading((prev) => ({ ...prev, fetchingActivities: false }));
      });
  };


  // Add new service provider
  const onAddServiceProvider = (providerData) => {
    setLoading((prev) => ({ ...prev, addingProvider: true }));

    addServiceProvider(providerData)
      .then((response) => {
        // Add the new provider to the list
        const newProvider = {
          name: providerData.name,
          taxNumber: providerData.taxNumber,
          activity: providerData.activity,
          isEnabled: true,
          canBeDeleted: true,
        };
        // setServiceProviders((prev) => [...prev]);
        onSearchHandler(""); // Refresh the list
        // Clear the search form
        setTaxpayerSearch("");
        setTaxpayerActivities([]);
        showToast({
          toastOptions: {type: "success",}, data: {
            variant: 'success', text: "Service provider added successfully",
          },
        });
      })
      .catch((error) => {
        console.error("Error adding service provider:", error);
        showToast({
          toastOptions: {type: "error",}, data: {
            variant: 'error', text: error.error,
          },
        })
      })
      .finally(() => {
        setLoading((prev) => ({ ...prev, addingProvider: false }));
      });
  };

  // Handle search filter for service providers list
  const onSearchHandler = (searchValue) => {
    setSearch({
      taxNumber: searchValue || "",
    });
  };

  // Handle taxpayer search input
  const onTaxpayerSearchChange = (taxNumber) => {
    setTaxpayerSearch(taxNumber);
    handleSearchTaxpayer(taxNumber);
  };

  // Fetch service providers on component mount and when search changes
  useEffect(() => {
    handleGetAllServiceProviders();
  }, [handleGetAllServiceProviders]);

  return (
    <React.Fragment>
      {loader && <Loading />}
      <ServiceProvider
        tab={tab}
        serviceProviders={serviceProviders}
        taxpayerActivities={taxpayerActivities}
        taxpayerSearch={taxpayerSearch}
        onAddServiceProvider={onAddServiceProvider}
        onSearchHandler={onSearchHandler}
        onTaxpayerSearchChange={onTaxpayerSearchChange}
        loading={loading}
      />
    </React.Fragment>
  );
};

export default React.memo(ServiceProviderContainer);
